import { object, string } from 'yup';
import { fields, createSchema, validate as _validate } from '..';

const {
  firstName,
  lastName,
  organisationName,
  email,
  urlSlug,
  requiredText,
  hslColor,
} = fields;

const schema = createSchema({
  firstName,
  lastName,
  organisationName,
  email,
  uniqueSlug: urlSlug,
  backupEmail: email,
  typeOfOrganisation: requiredText,
  logoFile: string().nullable(),
  colors: object().shape({
    mainColor: hslColor,
    secondaryColor: hslColor,
  }),
});

const validate = (data) => _validate(schema, data);

export default validate;
